export default __webpack_public_path__ + "static/media/asos.043feae0.png";